export default "__VITE_ASSET__ClvsiN2R__"